/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { meV4Schema } from './meV4Schema'

export const switchOrgResponseV4Schema = z
  .object({
    accessToken: z
      .string()
      .min(1)
      .default('')
      .describe('The new JWT access token, issued for the switched-into org/role context.'),
    expiresOn: z.iso
      .datetime({ offset: true, local: true })
      .default('')
      .describe('UTC moment the new access token expires.'),
    orgChanged: z
      .boolean()
      .default(false)
      .describe(
        'True when the active org id or org type actually changed — the UI must reload the full workspace.'
      ),
    user: meV4Schema.describe(
      'Shape returned by `GET /api/v4/me/getMe` — the app-shell identity plus the topbar counts.'
    ),
  })
  .describe(
    'Result of switching the active org/role context: the re-issued token plus the identity for the new context.\r\nAlso returned when accepting an invitation, which switches into the joined org.'
  )
